import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ReactFlagsSelect from 'react-flags-select'
import 'react-flags-select/css/react-flags-select.css'
import { setTenant } from '../../../actions/system'
import './styles.css'

const TenantSelector = (props) => {


  let toJeTenant = (countryCode) => {
    switch (countryCode.toLowerCase()) {
    case "gb":
      return "uk"
    default:
      return countryCode.toLowerCase()
    }
  }

  let toCountryCode = (tenant) => {
    switch (tenant.toLowerCase()) {
    case "uk":
      return "GB"
    default:
      return tenant.toUpperCase()
    }
  }

  let onSelectFlag = (countryCode) => {
    let tenant = toJeTenant(countryCode)
    // Full page reload with new tenant prefix (same approach as JETMS country change)
    window.location.href = '/' + tenant + '/pools'
  }

  let countries = window.env.tenants.map((item) => {
    switch (item.toLowerCase()) {
    case "uk":
      return "GB"
    default:
      return item.toUpperCase()
    }
  })

  return (<ReactFlagsSelect showSelectedLabel={false} alignOptions="left" onSelect={onSelectFlag} countries={countries} defaultCountry={toCountryCode(props.tenant)} />)
}

TenantSelector.propTypes = {
  setTenant: PropTypes.func.isRequired,
  tenant: PropTypes.string
}

TenantSelector.defaultProps = {
  tenant: ''
}

const mapStateToProps = (state, props) => {

  return {
    tenant: state.system.tenant
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  setTenant
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TenantSelector)



// WEBPACK FOOTER //
// ./src/components/header/tenantSelector/index.js